import controller from './products-list-filters.controller';
import templateBase from './templates/products-list-filters-base.view.html';


let ProductsListFiltersComponent = { 
    template:changeTemplate,
    controller,
    bindings: {
        shCtrl: '<'
    }
};

changeTemplate.$inject = ['SessionService'];

function changeTemplate(SessionService) {
    let response = SessionService.get('components');

    if (response.PRODUCT_LIST.component == 'template_t1') {
        return templateT1;
    } else if (response.PRODUCT_LIST.component == 'template_t2') {
        return templateT2;
    }else{
        return templateBase;
    }
}

export default ProductsListFiltersComponent;



// WEBPACK FOOTER //
// ./www/components/catalog/products-list-filters/products-list-filters.component.js